/**
 * Phase 9 P0 · 稀疏数据阈值定义 + 检查工具
 *
 * 原始动机:
 *   PR #26 后 06 ModelDetail 大量 panel 在数据稀疏时 (e.g. 1 个 L1 桶 / 2 周 trend)
 *   渲染成单条横条、断线趋势、几乎空的词云。这些被原型对照判为「render bug」.
 *   本模块定义 panel 最低数据要求, 不满足时统一回退到 <EmptyState>.
 */

export interface SparsityThreshold {
  /** 最少需要多少数据点才能正常渲染 */
  min: number;
  /** Empty 文案模板, `{n}` 占位实际值 */
  message: string;
}

export const SPARSITY_THRESHOLDS = {
  trend: { min: 4, message: '趋势数据回填中（当前 {n} 周 / 至少需 4 周）' },
  bar: { min: 3, message: '分类数据回填中（当前 {n} 类 / 至少需 3 类）' },
  wordcloud: { min: 8, message: '关键词数据不足（当前 {n} 个 / 至少需 8 个）' },
  radar: { min: 5, message: '评分维度数据不足（当前 {n} 维 / 至少需 5 维）' },
  quotes: { min: 1, message: '暂无典型样本' },
} as const satisfies Record<string, SparsityThreshold>;

export type SparsityKey = keyof typeof SPARSITY_THRESHOLDS;

export interface SparsityResult {
  ok: boolean;
  message: string;
  count: number;
}

/** Check if data is dense enough; if not, build a localized message. */
export function checkSparsity(kind: SparsityKey, count: number): SparsityResult {
  const cfg = SPARSITY_THRESHOLDS[kind];
  if (count >= cfg.min) {
    return { ok: true, message: '', count };
  }
  return {
    ok: false,
    count,
    message: cfg.message.replace('{n}', String(count)),
  };
}
